import { styled } from '@mui/material';

import { useI18n } from '@app-velocity/i18n';

import { InfoSection } from '../../../../components/InfoSection';
import { useReportContext } from '../../../../context/useReportContext';

const SingleMetricContainer = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  gap: theme.spacing(2),
  padding: `${theme.spacing(1)} 0`,
}));

const MetricData = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'baseline',
  gap: theme.spacing(2),
}));
const Value = styled('span')(({ theme }) => ({
  fontWeight: 700,
  fontSize: 20,
}));

const MetricDetails = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  gap: theme.spacing(1),
  fontWeight: 400,
  fontSize: 16,
  svg: {
    fill: '#1b1b1b',
  },
}));

export const Details = () => {
  const { t } = useI18n();
  const { statistics } = useReportContext();

  const { metrics, simulatedReviews, humanReviews } = statistics;

  const {
    simulatedInteractions,
    humanInteractions,
    minNumberOfSimInteracitons,
    maxNumberOfSimInteracitons,
    minNumberOfViews,
    maxNumberOfViews,
    simulationViewsCount,
  } = metrics;

  const totalSimulations = simulatedReviews.failed + simulatedReviews.succeded;

  const avgSimulatedInteractions =
    Math.round((simulatedInteractions * 100) / totalSimulations) / 100;

  const avgSimulatedViews =
    Math.round((simulationViewsCount * 100) / totalSimulations) / 100;

  const totalHumanTests = humanReviews
    ? humanReviews.failed + humanReviews.succeded
    : 0;

  const avgHumanInteractions = humanInteractions
    ? Math.round(humanInteractions / totalHumanTests)
    : 0;

  if (!totalHumanTests && !totalSimulations) return null;

  return (
    <InfoSection tooltip="prototypes:report.details.tooltip">
      <InfoSection.Title title="prototypes:report.details.title" />
      {totalSimulations ? (
        <>
          <SingleMetricContainer>
            <MetricData>
              <Value>{minNumberOfSimInteracitons}</Value>
              {maxNumberOfSimInteracitons > minNumberOfSimInteracitons ? (
                <>
                  - <Value>{maxNumberOfSimInteracitons}</Value>
                </>
              ) : null}
              <MetricDetails>
                {t('prototypes:report.metric.sim_interactions')}
              </MetricDetails>
            </MetricData>
          </SingleMetricContainer>
          {maxNumberOfSimInteracitons !== minNumberOfSimInteracitons ? (
            <SingleMetricContainer>
              <MetricData>
                <Value>{avgSimulatedInteractions.toFixed(1)}</Value>
                <MetricDetails>
                  {t('prototypes:report.metric.avg_sim_interactions')}
                </MetricDetails>
              </MetricData>
            </SingleMetricContainer>
          ) : null}
          <SingleMetricContainer>
            <MetricData>
              <Value>{minNumberOfViews}</Value>{' '}
              {maxNumberOfViews > minNumberOfViews ? (
                <>
                  - <Value>{maxNumberOfViews}</Value>
                </>
              ) : null}
              <MetricDetails>
                {t('prototypes:report.metric.sim_views')}
              </MetricDetails>
            </MetricData>
          </SingleMetricContainer>
          {maxNumberOfViews !== minNumberOfViews ? (
            <SingleMetricContainer>
              <MetricData>
                <Value>{avgSimulatedViews.toFixed(1)}</Value>
                <MetricDetails>
                  {t('prototypes:report.metric.avg_views_count')}
                </MetricDetails>
              </MetricData>
            </SingleMetricContainer>
          ) : null}
        </>
      ) : null}
      {totalHumanTests ? (
        <SingleMetricContainer>
          <MetricData>
            <Value>{avgHumanInteractions}</Value>
            <MetricDetails>
              {t('prototypes:report.metric.avg_human_interactions')}
            </MetricDetails>
          </MetricData>
        </SingleMetricContainer>
      ) : null}
    </InfoSection>
  );
};
